import { __rest, __assign } from 'tslib';
import * as React from 'react';
import { UitkIcon, UitkIconSize } from 'uitk-react-icons';
import { classNames } from 'uitk-react-utils';
import { UitkSpacing } from 'uitk-react-spacing';
import { UitkText } from 'uitk-react-text';
import styles from './uitk-seat-map.css';

var getClassNameList = classNames.bind(styles);
var UitkSeatMapButton = function (props) {
    var altText = props.altText, btnText = props.btnText, checked = props.checked, className = props.className, disabled = props.disabled, icon = props.icon, id = props.id, name = props.name, onChange = props.onChange, isConfirmed = props.isConfirmed, attributes = __rest(props, ["altText", "btnText", "checked", "className", "disabled", "icon", "id", "name", "onChange", "isConfirmed"]);
    var wrapperClassNameConfirmed = getClassNameList('uitk-seat-map-button', className, {
        'is-checked-confirmed': checked && isConfirmed
    });
    var btnClassName = getClassNameList('uitk-seat-map-button', className, {
        'is-checked': checked && !isConfirmed,
        'is-disabled': disabled,
        'is-confirmed': isConfirmed
    });
    var buttonBasicStructure = (React.createElement("div", { className: btnClassName },
        React.createElement("input", __assign({ id: id, name: name, type: "checkbox", onChange: onChange, className: getClassNameList('is-visually-hidden'), disabled: disabled, checked: checked, "aria-checked": checked, "aria-label": altText }, attributes)),
        React.createElement("label", { "aria-hidden": true, className: getClassNameList('uitk-seat-map-button-content'), htmlFor: id },
            icon && (React.createElement(UitkIcon, { className: getClassNameList('uitk-seat-map-button-icon'), name: icon, size: UitkIconSize.EXTRA_SMALL })),
            btnText && (React.createElement(UitkText, { className: isConfirmed ? getClassNameList('uitk-seat-map-button-content-label') : undefined, align: "center", theme: isConfirmed ? undefined : 'emphasis', weight: isConfirmed ? undefined : 'medium', size: isConfirmed ? 300 : 200, inline: true }, btnText)))));
    if (isConfirmed) {
        return (React.createElement("div", { className: wrapperClassNameConfirmed },
            React.createElement(UitkSpacing, { padding: checked ? 'half' : undefined }, buttonBasicStructure)));
    }
    return buttonBasicStructure;
};
UitkSeatMapButton.displayName = 'UitkSeatMapButton';
UitkSeatMapButton.defaultProps = {
    checked: false,
    disabled: false
};

export { UitkSeatMapButton };
